export default [
  {
    path: '/dashboard/:key?',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: {},
  },
  {
    path: '/initialinformationdeclaration/:key?',
    name: 'InitialInformationDeclaration',
    component: () => import('@/views/initialInformationDeclaration/InitialInformationDeclaration.vue'),
    meta: {},
  },
];
